import type { ConsentPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function appendPatientConsent(body: ConsentPayloadDTO) {
  return patientRequestsTyped.append_patient_consent({ body, context: { showLoader: false } });
}
